import { Link, Text } from '@revelio/ui';

import type { GlobalAssistantAccessDecision } from './global-ai-assistant-access';
import styles from './global-ai-assistant-permission-upsell.module.css';

const SALES_EMAIL = 'sales@reveliolabs.com';
const SALES_MAILTO = `mailto:${SALES_EMAIL}?subject=Dashboard%20access`;

type DeniedAccess = Exclude<GlobalAssistantAccessDecision, { allowed: true }>;

export function GlobalAssistantPermissionUpsell({
  access,
  'data-testid': dataTestId,
}: {
  access: DeniedAccess;
  'data-testid'?: string;
}) {
  return (
    <div className={styles.upsell} data-testid={dataTestId}>
      <div className={styles.messageBody}>
        <Text fontSize="x-sm" className={styles.text}>
          {access.message}{' '}
          <Link
            className={styles.salesLink}
            href={SALES_MAILTO}
            data-testid="global-ai-permission-upsell-email-sales"
          >
            {SALES_EMAIL}
          </Link>
        </Text>
      </div>
    </div>
  );
}
